export enum SystemAlertType {
  Unknown = 'Unknown',
  SystemOffline = 'SystemOffline',
  IS32Error = 'IS32Error',
  IS32EarthError = 'IS32EarthError',
  IS32PowerError = 'IS32PowerError',
  IS32BatteryError = 'IS32BatteryError',
  IS32CentralError = 'IS32CentralError',
  IS32SystemError = 'IS32SystemError',
  IPUnitLocalBusError = 'IPUnitLocalBusError',
  IPUnitConfigurationError = 'IPUnitConfigurationError',
  IPUnitHighFrequencyError = 'IPUnitHighFrequencyError',
  IPUnitWirelessG2Error = 'IPUnitWirelessG2Error',
  IPUnitWirelessG2InterferenceError = 'IPUnitWirelessG2InterferenceError',
}
